import Axios, { AxiosError } from 'axios';
import { UPDATE_AUTO_PAY_REQUEST, UPDATE_AUTO_PAY_FAILURE, UPDATE_AUTO_PAY_SUCCESS } from '../constants/autoPay';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '../combineReducers';
import { updateAutoPayParams } from '../interfaces/autoPay';
import { sendError } from '@pec/aion-ui-core/sendError';

const updateAutoPayRequest = () =>
  ({
    type: UPDATE_AUTO_PAY_REQUEST
  } as const);

const updateAutoPaySuccess = () =>
  ({
    type: UPDATE_AUTO_PAY_SUCCESS
  } as const);

const updateAutoPayFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: UPDATE_AUTO_PAY_FAILURE,
    error
  } as const;
};

export const updateAutoPay = (
  params: updateAutoPayParams
): ThunkAction<void, RootState, null, Actions> => async dispatch => {
  try {
    dispatch(updateAutoPayRequest());

    await Promise.all([
      Axios.patch(`/api/v2/Organizations/${params.organizationId}`, [
        {
          op: 'replace',
          path: '/AutoPay',
          value: params.value
        }
      ]),
      Axios.patch(`/api/v1/billing/Company/${params.companyId}/autoconnect`, {
        id: params.companyId,
        autoConnectStatus: params.consentValue,
        email: params.email
      })
    ]);

    params.afterSuccess && params.afterSuccess();

    dispatch(updateAutoPaySuccess());
  } catch (error) {
    dispatch(updateAutoPayFailure(error));
  }
};

export type Actions =
  | ReturnType<typeof updateAutoPayRequest>
  | ReturnType<typeof updateAutoPaySuccess>
  | ReturnType<typeof updateAutoPayFailure>;
